import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";
import { TESTIMONIALS } from "@/lib/site";

export default function Testimonials({ compact = false }) {
    const items = compact ? TESTIMONIALS.slice(0, 3) : TESTIMONIALS;
    return (
        <section className="relative py-24 lg:py-32 bg-[#080E20]" data-testid="testimonials-section">
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
                <div className="max-w-2xl mb-16">
                    <p className="overline">Traveler Stories</p>
                    <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium mt-4 leading-tight">
                        Words from those who <em className="italic text-gold">flew away with us.</em>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                    {items.map((t, i) => (
                        <motion.figure
                            key={t.name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.7, delay: i * 0.1 }}
                            className="relative p-8 lg:p-10 bg-navy-surface border border-white/10 flex flex-col h-full"
                            data-testid={`testimonial-${i}`}
                        >
                            <Quotes size={36} weight="fill" className="text-gold/70 absolute top-6 right-6" />
                            <div className="flex items-center gap-1 text-gold">
                                {Array.from({ length: t.rating }).map((_, idx) => (
                                    <Star key={idx} size={16} weight="fill" />
                                ))}
                            </div>
                            <blockquote className="font-serif italic text-xl lg:text-2xl leading-snug text-white mt-6">
                                “{t.text}”
                            </blockquote>
                            <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-white/10">
                                <img src={t.image} alt={t.name} className="w-12 h-12 object-cover rounded-full border border-gold/40" />
                                <div>
                                    <p className="font-sans text-sm text-white">{t.name}</p>
                                    <p className="font-sans text-xs text-white/50 uppercase tracking-widest mt-0.5">{t.role}</p>
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
